import { inject } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { InitialData } from '@/typings/app.types';
import { User } from '@app/modules/admin/user/user.types';

import { NavigationService } from '@app/core/navigation/navigation.service';
import { NotificationsService } from '@app/layout/common/notifications/notifications.service';
import { UserService } from '@app/modules/admin/user/user.service';

//import { ShortcutsService } from '@app/layout/common/shortcuts/shortcuts.service';
//import { MessagesService } from '@app/layout/common/messages/messages.service';
//import { QuickChatService } from '@app/layout/common/quick-chat/quick-chat.service';

export const initialDataResolver = (): Observable<InitialData> => {
    const navigationService = inject(NavigationService);
    const notificationsService = inject(NotificationsService);
    const userService = inject(UserService);

    //const shortcutsService = inject(ShortcutsService);
    //const messagesService = inject(MessagesService);
    //const quickChatService = inject(QuickChatService);

    // Fork join multiple API endpoint calls to wait all of them to finish
    return forkJoin({
        user: userService.get().pipe(
            // Signout on error handled by auth interceptor
            catchError(() => of(null as User | null))
        ),
        navigation: navigationService.get().pipe(catchError(() => of([] as unknown[]))),
        notifications: notificationsService.getAll().pipe(catchError(() => of([] as unknown[]))),

        //shortcuts: shortcutsService.getAll().pipe(catchError(() => of([]))),
        //messages: messagesService.getAll().pipe(catchError(() => of([]))),
        //chats: quickChatService.getChats().pipe(catchError(() => of([]))),
    });
};
